import { TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { Severity, Status } from "src/app/configurations/inventory/constants/constants";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { AppMainComponent } from "src/app/app.main.component";
import { SharedChannelService } from "src/app/modules/shared/services/channel.service";
import { ChannelN } from "src/app/modules/shared/models/channel.model";
import { AccountModuleId } from "src/app/modules/shared/constants/modules.constant";
import { Observable, Subject, catchError, firstValueFrom, forkJoin, of, takeUntil } from "rxjs";
import { IAccountTransactionMaster, IAccountTransactions, IBankRegister } from "src/app/finance/models/bank-register.model";
import { FinanceService } from "src/app/finance/finance.service";
import { FinanceUtilityService } from "src/app/finance/util/finance-utility.service";
import { AccountsTransactionType, TransactionNames } from "src/app/finance/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
import { GelAllAccountRequestModel } from "src/app/accounts-v2/models/account-request.model";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "src/app/inventory/sales-order/services/account-flattening.service";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { OverlayPanel } from "primeng/overlaypanel";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";

@Component({
    selector: "app-user-register",
    templateUrl: "./user-register.component.html",
    styleUrls: ["./user-register.component.scss"],
})
export class UserRegisterComponent implements OnInit, OnChanges, OnDestroy {
    @Input() display;
    @Input() selectedFinance;
    @Input() bankRegisterId;
    @Input() accountsTransactionMasterID;
    @Input() dialogType;
    @Input() isShowVoidDelete: boolean = true;
    @Input() isEditableViewDialog: boolean = true;
    @Output() close = new EventEmitter();
    @Output() closeResister = new EventEmitter();
    @ViewChild("op", { static: false }) panel;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @ViewChild("transaction") transactionPanel: OverlayPanel;

    balanceAmt = 0;
    bankName;
    banks = [];
    selectedBank;
    showFloatHeader = false;

    displayAddRegister = false;
    payTo = "vendor";
    allVendors: any[] = [];
    allVendorsDD: any[] = [];
    selectedVendor;
    accountChannels = [];
    allUser : any[] = [];
    selectedChannel = null;
    allAccountsDD = [];
    selectedAccount;
    accountInfo;
    financialAccounts: any[] = [];
    selectedFinancialAccount;
    pmtOption = "payment";
    today = new Date();
    selectedDate: any;
    bandRegisterHeader: string = "Add New Register";
    EditBankRegisters: any;

    selectedRegister;
    displayUndepositedFunds = false;
    displayWriteCheck = false;
    overviewRefId: number = 0;
    displayAddEditExpense: boolean = false;
    displayInventoryOverview: boolean = false;
    inventoryOverviewRefId: number = 0;
    inventoryOverviewRefNumber: string = "";
    inventoryOverviewModule: string = "";

    transactionForm: FormGroup;
    accountTransactionMasterList: IAccountTransactionMaster[] = [];
    bankRegisters = [];
    bankRegisterDetails = [];
    checkDialogType = "VIEW";
    editDetails: any;
    displayMakeDepositViewDialog: boolean = false;
    selecteddepositId: number = 0;
    displayFundTransfer: boolean = false;
    fundTransferDialogType = "VIEW";
    selectedtransferFundId: number = 0;
    isVoided: boolean = false;
    isSplitAmountApplied: boolean = false;
    isTransactionTypePayment: boolean = false;

    // fraction digits
    fractionDigits: number = 0;
    statementMessage: string = "";

    splitAccount: boolean = false;
    splitViewTotalAmount = 0;

    totalAmount = 0;
    
    isAllowPostingPeriod: boolean = false;
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;

    constructor(
        private confirmationService: ConfirmationService,
        public app: AppMainComponent,
        private purchaseService: PurchasesService,
        private salesOrderService: SalesOrderService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        public appMainService: AppMainService,
        private financeService: FinanceService,
        private fb: FormBuilder,
        private accountServiceN: AccountServiceN,
        private sharedChannelService: SharedChannelService,
        private financeUtilityService: FinanceUtilityService,
        private importService: ImportserialService,
        private accountFlatteningService: AccountFlatteningService,
        private utilityService: UtilityService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedFinance && changes.selectedFinance.currentValue) {
            this.selectedFinance = changes.selectedFinance.currentValue;
            this.loadFinancialAccounts();
        }
        if (changes.bankRegisterId && changes.accountsTransactionMasterID) {
            this.bankRegisterId = changes.bankRegisterId.currentValue;
            this.accountsTransactionMasterID = changes.accountsTransactionMasterID.currentValue;
            this.getAllusersAndProcessEdit()
          }
        if (changes.dialogType && changes.dialogType) {
            this.dialogType = changes.dialogType.currentValue;
            if (this.dialogType === "VIEW") {
                this.display = false;
            }
        }
    }

    ngOnInit(): void {
        this.getFractionDigits();
        this.getIsetting();
        this.calculateBalance();
        this.selectedDate = this.today;
        this.initTransactionForm();
        this.getAccountChannels(AccountModuleId);
        this.addTransaction();
        if(this.dialogType != 'edit' && this.dialogType != 'VIEW'){
        this.getAllUsersAndSet();
        }
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
    getAllusersAndProcessEdit(){
        (async () => {
            const users = await firstValueFrom(this.getAllUsers());
            this.allUser = users;
            this.getBankRegisterDetailsById(this.bankRegisterId);
          })();
    }
    initTransactionForm() {
        this.transactionForm = this.fb.group(
            {
                id: [0],
                vendorId: [""],
                employeeId: [""],
                accountChannelId: [""],
                accountId: [""],
                transactionDate: [this.app._showDateTimeWithZone(new Date()), Validators.required],
                lineMemo: [""],
                transactionLineNumber: [""],
                financialAccount: [null, Validators.required],
                paymentAmount: [0],
                depositAmount: [0],
                transactions: this.fb.array([]),
                memo: [""],
            },
            { validators: [this.singleAmountValidator] },
        );
    }
    getAllUsersAndSet(): void {
        this.salesOrderService.getAllUser().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(users => {
            this.allUser = users;
          });
      }
    getAllUsers(): Observable<any> {
        return this.salesOrderService.getAllUser().pipe(takeUntil(this.ngUnsubscribe$));
      }
    singleAmountValidator(formGroup: FormGroup) {
        const paymentAmount = formGroup.get("paymentAmount")?.value;
        const depositAmount = formGroup.get("depositAmount")?.value;

        if (paymentAmount && depositAmount) {
            return { bothAmountsEntered: true };
        }
        if (!paymentAmount && !depositAmount) {
            return { noAmountEntered: true };
        }
        if ((paymentAmount === 0 || paymentAmount === null || paymentAmount === undefined) && (depositAmount === 0 || depositAmount === null || depositAmount === undefined)) {
            return { bothAmountsCannotBeZero: true };
        }
        return null;
    }

    setFormValidation() {
        if (this.payTo == "vendor") {
            this.transactionForm.controls.vendorId.setValidators(Validators.required);
            this.transactionForm.controls.vendorId.updateValueAndValidity();
            this.transactionForm.controls.accountId.clearValidators();
            this.transactionForm.controls.accountId.updateValueAndValidity();
            this.transactionForm.controls.employeeId.clearValidators();
            this.transactionForm.controls.employeeId.updateValueAndValidity();
        } else if (this.payTo == "customer") {
            this.transactionForm.controls.accountId.setValidators(Validators.required);
            this.transactionForm.controls.accountId.updateValueAndValidity();
            this.transactionForm.controls.vendorId.clearValidators();
            this.transactionForm.controls.vendorId.updateValueAndValidity();
            this.transactionForm.controls.employeeId.clearValidators();
            this.transactionForm.controls.employeeId.updateValueAndValidity();
        }  else if (this.payTo == "employee") {
            this.transactionForm.controls.employeeId.setValidators(Validators.required);
            this.transactionForm.controls.employeeId.updateValueAndValidity();
            this.transactionForm.controls.vendorId.clearValidators();
            this.transactionForm.controls.vendorId.updateValueAndValidity();
            this.transactionForm.controls.accountId.clearValidators();
            this.transactionForm.controls.accountId.updateValueAndValidity();
        }else {
            this.transactionForm.controls.vendorId.clearValidators();
            this.transactionForm.controls.vendorId.updateValueAndValidity();
            this.transactionForm.controls.accountId.clearValidators();
            this.transactionForm.controls.accountId.updateValueAndValidity();
            this.transactionForm.controls.employeeId.clearValidators();
            this.transactionForm.controls.employeeId.updateValueAndValidity();
        }
    }

    get isSaveButtonDisabled(): boolean {
        if (this.splitAccount) {
            const isTransactionsValid = this.transactions.valid && this.transactions.length > 0;
            let isVendorOrAccountValid = true;
            if (this.payTo === "vendor") {
                isVendorOrAccountValid = !!this.transactionForm.get("vendorId")?.value;
            } else if (this.payTo === "customer") {
                isVendorOrAccountValid = !!this.transactionForm.get("accountId")?.value;
            } else if (this.payTo === "employee") {
                isVendorOrAccountValid = !!this.transactionForm.get("employeeId")?.value;
            }
            return !isTransactionsValid || !isVendorOrAccountValid;
        } else {
            return !this.transactionForm.valid;
        }
    }

    onSplitAccountChange(isSplitAccountEnabled: boolean): void {
        const transactionsArray = this.transactionForm.get("transactions") as FormArray;
        if (isSplitAccountEnabled && transactionsArray?.length === 0) {
            this.addTransaction();
        }
        if (isSplitAccountEnabled) {
            transactionsArray.enable();
        } else {
            transactionsArray.disable();
        }
        this.transactionForm.updateValueAndValidity();


        if(this.dialogType === "edit" && !this.splitAccount) {
            this.transactionForm.patchValue({
                financialAccount: null,
                paymentAmount: 0,
                depositAmount: 0
            });
        }
    }

    /** Add/remove Multiple Transactions */

    get transactions(): FormArray {
        return this.transactionForm.get("transactions") as FormArray;
    }
    addTransaction() {
        const entryGroup = this.fb.group(
            {
                id: [0],
                financialAccountId: [null, Validators.required],
                amount: [0, Validators.required],
                transactionsmemo: [""],
            },
            { validators: this.financialAccountRequiredIfAmountPresent() },
        );
        this.transactions.push(entryGroup);
    }
    removeTransaction(index: number) {
        this.transactions.removeAt(index);
        this.calculateSplitViewTotalAmount(); // Recalculate total amount after removing a transaction
    }

    financialAccountRequiredIfAmountPresent(): ValidatorFn {
        return (formGroup: AbstractControl): { [key: string]: any } | null => {
            const amount = formGroup.get("amount")?.value;
            const financialAccountId = formGroup.get("financialAccountId")?.value;
            return amount && !financialAccountId ? { financialAccountRequired: true } : null;
        };
    }

    /** End Add/remove Multiple Transactions */

    addRegister() {
        this.allVendorList();
        this.displayAddRegister = true;
        this.initTransactionForm();
        this.setFormValidation();
        this.getAccountChannels(AccountModuleId);
        this.dialogType = "add";
        this.addTransaction();
        this.splitAccount = false;
        this.onSplitAccountChange(this.splitAccount);
        this.splitViewTotalAmount = 0; // Reset the split view total amount
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

    getIsetting() {
        this.appMainService.isShowSpinner("loadISettings");
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
        this.appMainService.isHideSpinner("loadISettings");
    }

    getBankRegisterDetailsById(id: number) {
        if (!id) return;
        this.financeService
            .getBankRegisterDetails(id, this.accountsTransactionMasterID)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.editDetails = res;
                    this.isVoided = res?.isVoided;
                    this.selectedBank = { name: this.editDetails?.bankFinancialAccountName };
                    // this.bankRegisters = res?.accountTransactionMaster && res?.accountTransactionMaster?.length > 0 ? res?.accountTransactionMaster[0]?.accountTransactions : [];
                    this.bankRegisterDetails = res?.accountTransactionMaster && res?.accountTransactionMaster?.length > 0 ? res?.accountTransactionMaster[0]?.accountTransactions : [];
                    this.currentPostingPeriodInfo = {
                        postingDate: res?.accountTransactionMaster[0]?.postingDate,
                        postingMonth: res?.accountTransactionMaster[0]?.postingMonth,
                        postingYear: res?.accountTransactionMaster[0]?.postingYear
                    };
                    this.calculateBalance();
                    this.view();
                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }
    changeFloatHeader() {
        this.showFloatHeader = false;
        setTimeout(() => {
            this.showFloatHeader = true;
        }, 300);
    }

    getAccountChannels(id: number) {
        this.sharedChannelService
            .getChannels(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res: ChannelN[]) => {
                    this.accountChannels = res;
                    this.selectedChannel = this.accountChannels?.filter((ac) => ac.isDefault == true)[0];
                    //this.transactionForm?.controls?.accountChannelId?.setValue(this.selectedChannel);
                    this.transactionForm.get("accountChannelId").setValue(this.selectedChannel);
                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }

    onChangeAccountChannel() {
        this.selectedAccount = null;
        this.transactionForm?.controls?.accountId?.setValue("");
    }

    filterAccount(event) {
        let query = event?.query;
        if (!event?.query?.toLowerCase()) {
            this.allAccountsDD = [];
            return;
        }
        const typeId = this.transactionForm?.controls?.accountChannelId?.value?.id || event.channelId || 0;
        this.appMainService.isShowSpinner("getAccountList");
        this.accountServiceN
            .getAccountsByNameWithHierarchy(typeId, event.query.toLowerCase())
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.allAccountsDD = this.accountFlatteningService.flattenAccounts(response);
                        if (this.dialogType === "VIEW") {
                            const accountName = this.allAccountsDD.find((data) => data?.businessName == query);
                            this.transactionForm.patchValue({
                                accountId: accountName,
                            });
                        }
                    }
                    this.appMainService.isHideSpinner("getAccountList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
                complete: () => {
                    this.appMainService.isHideSpinner("getAccountList");
                },
            });
    }
    async selectAccount(c) {
        this.accountInfo = null;
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(c.id);
    }

    prepareAccountTransactions() {
        let accTransactions: IAccountTransactions[] = [];

        if (this.splitAccount && this.transactions?.controls?.length > 0 && this.transactions?.at(0)?.get("financialAccountId")?.value) {
            this.transactions?.controls?.forEach((transactionGroup: FormGroup, index: number) => {
                const amount = transactionGroup?.controls?.amount?.value ?? 0;
                const financialAccountId = transactionGroup?.controls?.financialAccountId?.value?.id ?? 0;
                let accTransaction: IAccountTransactions = {
                    id: this.dialogType === "edit" ? transactionGroup?.controls?.id?.value : 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    accountTransactionMasterId: 0 || this.bankRegisterDetails[index]?.accountTransactionMasterId,
                    accountClientChartId: this.dialogType === "edit" ? this.bankRegisterDetails[index]?.accountClientChartId : 0,
                    amount: this.splitAccount ? Number(amount) : Number(this.transactionForm.get("depositAmount")?.value) * -1,
                    financialAccountId: financialAccountId,
                    accountListTypeId: this.payTo == "vendor" ? 2 : this.payTo == "customer" ? 1 : this.payTo == "employee" ? 3 : 0,
                    referenceId: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.id || 0 : this.payTo == "customer" ? this.transactionForm.controls.accountId?.value?.id || 0 : this.payTo == "employee" ? this.transactionForm.controls.employeeId?.value?.id || 0 : 0,
                    lineMemo: transactionGroup?.controls?.transactionsmemo?.value ?? "",
                    transactionLineNumber: 0,
                    voidAmount: 0,
                    businessName: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.name || "" : this.payTo == "customer" ? this.transactionForm.controls.accountId?.value?.businessName || "" : this.payTo == "employee" ? this.transactionForm.controls.employeeId?.value?.name || "" : "",
                    isBalanceEntry: false,
                    channelId: this.payTo == "vendor" ? 0 : this.payTo == "customer" ? this.transactionForm.controls.accountChannelId?.value?.id || this.selectedChannel?.id : 0,
                };
                accTransactions.push(accTransaction);
            });
        } else {
            let accTransaction: IAccountTransactions = {
                id: this.dialogType === "edit" ? this.bankRegisterDetails[0]?.id : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                accountTransactionMasterId: this.dialogType === "edit" ? this.bankRegisterDetails[0]?.accountTransactionMasterId : 0,
                accountClientChartId: this.dialogType === "edit" ? this.bankRegisterDetails[0]?.accountClientChartId : 0,
                amount: this.transactionForm.get("paymentAmount")?.value > 0 ? Number(this.transactionForm.get("paymentAmount")?.value) : Number(this.transactionForm.get("depositAmount")?.value) * -1,
                financialAccountId: this.transactionForm?.controls?.financialAccount?.value?.id ?? 0,
                accountListTypeId: this.payTo == "vendor" ? 2 : this.payTo == "customer" ? 1  : this.payTo == "employee" ? 3 : 0,
                referenceId: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.id || 0 : this.payTo == "customer" ? this.transactionForm.controls.accountId?.value?.id || 0 :
                this.payTo == "employee" ? this.transactionForm.controls.employeeId?.value?.id || 0 : 0,
                lineMemo: "",
                transactionLineNumber: 0,
                voidAmount: 0,
                businessName: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.name || "" : this.payTo == "customer" ? this.transactionForm.controls.accountId?.value?.businessName || ""  : this.payTo == "employee" ? this.transactionForm.controls.employeeId ?.value?.name || "" : "",
                isBalanceEntry: false,
                channelId: this.payTo == "vendor" ? 0 : this.payTo == "customer" ? this.transactionForm.controls.accountChannelId?.value?.id || this.selectedChannel?.id : 0,
            };
            accTransactions.push(accTransaction);
        }

        let accBalanceTransaction: IAccountTransactions = {
            id: this.dialogType === "edit" ? this.bankRegisterDetails[this.bankRegisterDetails?.length - 1]?.id : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            accountTransactionMasterId: this.dialogType === "edit" ? this.bankRegisterDetails[this.bankRegisterDetails?.length - 1]?.accountTransactionMasterId : 0,
            accountClientChartId: this.dialogType === "edit" ? this.bankRegisterDetails[this.bankRegisterDetails?.length - 1]?.accountClientChartId : 0,
            amount: this.splitAccount ? Number(this.splitViewTotalAmount) * -1 : this.transactionForm.get("paymentAmount")?.value > 0 ? Number(this.transactionForm.get("paymentAmount")?.value) * -1 : this.transactionForm.get("depositAmount")?.value,
            financialAccountId: this.dialogType === "edit" ? this.bankRegisterDetails[this.bankRegisterDetails?.length - 1]?.financialAccountId : this.selectedBank?.id || 0, // check
            accountListTypeId: this.payTo == "vendor" ? 2 : this.payTo == "customer" ? 1  : this.payTo == "employee" ? 3: 0,
            referenceId: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.id || 0 : this.payTo == "customer" ? this.transactionForm.controls.accountId?.value?.id || 0 : 0,
            lineMemo: "",
            transactionLineNumber: 0,
            voidAmount: 0,
            businessName: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.name || "" : this.payTo == "customer" ? this.transactionForm.controls.accountId?.value?.businessName || "" : this.payTo == "employee" ? this.transactionForm.controls.employeeId?.value?.name || "": "",
            isBalanceEntry: true,
            channelId: this.payTo == "vendor" ? 0 : this.payTo == "customer" ? this.selectedChannel?.id : 0,
        };
        accTransactions.push(accBalanceTransaction);
        return accTransactions;
    }

    prepareAccountTransactionMasterList() {
        let accountMaster: IAccountTransactionMaster = {
            id: this.dialogType === "edit" ? this.bankRegisterDetails[0]?.accountTransactionMasterId : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            organizationId: this.app.companyId,
            transactionReferenceId: this.editDetails?.accountTransactionMaster[0]?.transactionReferenceId || 0,
            accountsTransactionTypeId: AccountsTransactionType.BankRegister,
            referenceId: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.id || 0 : this.payTo == "customer" ? this.transactionForm.controls.accountId?.value?.id || 0 : this.payTo == "employee" ? this.transactionForm.controls.employeeId?.value?.id || 0  : 0,
            transactionDate: this.app._saveDateTimeWithZone(this.transactionForm.controls.transactionDate.value),
            accountsTransactionVoidId: 0,
            accountTransactions: this.prepareAccountTransactions(),
            businessName: "",
            channelId: this.payTo == "vendor" ? 0 : this.payTo == "customer" ? this.transactionForm.controls.accountChannelId?.value?.id || this.selectedChannel?.id : 0,
            memo: this.transactionForm.controls.memo?.value ?? "",
            docNumber: this.transactionForm.controls.lineMemo?.value ?? "",
            postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.dialogType == "edit" ? this.app._saveDateTimeWithZone(this.currentPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(this.transactionForm.controls.transactionDate.value),
            postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.dialogType == "edit" ? new Date(this.currentPostingPeriodInfo?.postingDate).getMonth() + 1 : new Date(this.transactionForm.controls.transactionDate.value).getMonth() + 1,
            postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.dialogType == "edit" ? new Date(this.currentPostingPeriodInfo?.postingDate).getFullYear() : new Date(this.transactionForm.controls.transactionDate.value).getFullYear()
        
        };
        this.accountTransactionMasterList.push(accountMaster);
    }

    getTotalTransactionAmount(): number {
        let totalAmount = 0;
        this.transactions.controls.forEach((transactionGroup: FormGroup) => {
            const amount = transactionGroup?.controls?.amount?.value ?? 0;
            totalAmount += Number(amount);
        });
        return totalAmount;
    }

    calculateSplitViewTotalAmount(): void {
        this.splitViewTotalAmount = this.transactions?.controls?.reduce((total, control) => {
            const amount = control?.get("amount")?.value ?? 0;
            return total + amount;
        }, 0);
    }

    addManualRegisterInList() {
        const transactionGroup = this.transactions?.at(0) as FormGroup;
        this.isSplitAmountApplied = this.transactions?.controls?.length > 0 && this.transactions?.at(0)?.get("financialAccountId")?.value ? true : false;
        this.isTransactionTypePayment = this.transactionForm.get("paymentAmount")?.value > 0 ? true : false;
        let data = {
            id: this.bankRegisters.length + 1,
            createdDate: this.transactionForm?.controls?.transactionDate?.value,
            txnNumber: this.transactionForm?.controls?.lineMemo?.value || "",
            businessName: this.payTo == "vendor" ? this.transactionForm.controls.vendorId?.value?.name : this.payTo == "customer" ? this.transactionForm?.controls?.accountId?.value?.businessName : this.payTo == "employee" ? this.transactionForm?.controls?.employeeId?.value?.name :  "",
            financialAccountName: this.transactions?.controls?.length > 0 && this.transactions?.at(0)?.get("financialAccountId")?.value ? "--split--" : (this.transactionForm?.controls?.financialAccount?.value?.name ?? ""),
            amount: this.splitAccount ? this.splitViewTotalAmount : this.transactionForm.get("paymentAmount")?.value > 0 ? Number(this.transactionForm.get("paymentAmount")?.value) : Number(this.transactionForm.get("depositAmount")?.value) * -1,
            isSplitBalance: this.splitAccount,
            payTo: this.payTo,
        };
        this.bankRegisters.push(data);
    }

    saveTransaction() {
        if (!!this.statementMessage) {
            return;
        }
        if (this.payTo === "customer") {
            this.selectedChannel = this.transactionForm?.get("accountChannelId").value;
        }
        this.prepareAccountTransactionMasterList();
        this.calculateBalance();
        if (this.dialogType && this.dialogType !== "edit") {
            if(!this.isAllowPostingPeriod){
                this.updatedPostingPeriodInfo = {
                    postingDate:  this.app._saveDateTimeWithZone(this.transactionForm.controls.transactionDate.value),
                    postingMonth : new Date(this.transactionForm.controls.transactionDate.value).getMonth() + 1,
                    postingYear : new Date(this.transactionForm.controls.transactionDate.value).getFullYear()
                } 
            }
            this.addManualRegisterInList();
            this.calculateBalance();
            this.displayAddRegister = false;
            this.closeTransactionPanel();
            this.transactionForm.reset();
        } else {
            this.saveBankRegister();
        }
    }

    saveAndNewTransaction() {
        if (!!this.statementMessage) {
            return;
        }
        this.prepareAccountTransactionMasterList();
        this.addManualRegisterInList();
        this.calculateBalance();
        this.initTransactionForm();
        this.transactions.clear();
        this.addTransaction();
        this.closeTransactionPanel();
        this.splitViewTotalAmount = 0; // Reset the split view total amount

        const transactionsArray = this.transactionForm.get("transactions") as FormArray;
        if (this.splitAccount) {
            transactionsArray.enable();
        } else {
            transactionsArray.disable();
        }
        this.transactionForm.updateValueAndValidity();
    }
    closeAddRegister() {
        if (this.display) {
            this.displayAddRegister = false;
            this.closeTransactionPanel();
        } else {
            this.close.emit();
            this.closeResister.emit();
        }
    }

    saveBankRegister() {
        
        let bankregister: IBankRegister = {
            id: this.editDetails?.id ? this.editDetails?.id : 0,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: this.app._saveDateTimeWithZone(new Date()),
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            organizationId: this.app.companyId,
            userId: this.app.user.userId,
            accountsTransactionVoidId: 0,
            bankFinancialAccountId: this.selectedBank?.id || this.editDetails?.bankFinancialAccountId,
            accountTransactionMaster: this.accountTransactionMasterList,
            isSplitView: this.splitAccount,
            isPayment: this.splitAccount ? (Number(this.splitViewTotalAmount) > 0 ? true : false) : this.isTransactionTypePayment,
        };
        if (this.dialogType !== "edit") {
            this.appMainService.isShowSpinner("savebankregister");
            this.financeService
                .saveBankRegister(bankregister)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (data) => {
                        this.appMainService.isHideSpinner("savebankregister");
                        this.messageService.add({
                            severity: Severity.Success,
                            summary: this.titlecasePipe.transform(Severity.Success),
                            detail: "Saved Successfully ...",
                        });
                        this.onClose("save");
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner("savebankregister");
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred ...",
                        });
                    },
                });
        } else {
            this.appMainService.isShowSpinner("updateBankRegister");
            this.financeService
                .updateBankRegister(bankregister)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (data) => {
                        this.appMainService.isHideSpinner("updateBankRegister");
                        this.messageService.add({
                            severity: Severity.Success,
                            summary: this.titlecasePipe.transform(Severity.Success),
                            detail: "Updated Successfully ...",
                        });
                        this.displayAddRegister = false;
                        this.onClose("save");
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner("updateBankRegister");
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred ...",
                        });
                    },
                });
        }
    }

    getAllBankRegisters() {
        if (this.selectedBank && this.selectedBank?.id != 0) {
            this.appMainService.isShowSpinner("loadbankregisters");
            this.financeService
                .getAllBankRegisters(this.selectedBank?.id || 0)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: (registers) => {
                        this.appMainService.isHideSpinner("loadbankregisters");
                        this.bankRegisters = registers?.map((r) => {
                            const register = { ...r, createdDate: this.app._showDateTimeWithZone(r.createdDate) };
                            return register;
                        });
                        this.calculateBalance();
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner("loadbankregisters");
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: "Error occurred ...",
                        });
                    },
                });
        }
    }

    loadFinancialAccounts(bankRegister?: any) {
        this.appMainService.isShowSpinner("loadaccounts");
        this.financeService
            .getAllFinancialAccounts(false)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (accounts) => {
                    this.prepareFinancialAccountsData(accounts);
                    this.appMainService.isHideSpinner("loadaccounts");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadaccounts");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }
    prepareFinancialAccountsData(accounts) {
        let acc = JSON.parse(JSON.stringify(accounts));
        this.financialAccounts = this.financeUtilityService.prepareFinancialAccountsData(acc);
        if (this.dialogType !== "VIEW") {
            this.prepareBankAccountsData(this.financialAccounts);
        }
    }

    findMatchingParentChildrenId(id: number, nodes: any[]): any | null {
        for (const node of nodes) {
            if (node.id === id) {
                return node;
            }
            if (node.children) {
                const matchingChild = this.findMatchingParentChildrenId(id, node.children);
                if (matchingChild) {
                    return matchingChild;
                }
            }
        }
        return null;
    }

    prepareBankAccountsData(accounts) {
        let assetData = accounts?.find((a) => a?.name?.toLowerCase() == "assets");
        let bankData = assetData?.children?.filter((b) => b?.subAccountType?.name?.toLowerCase() == "bank");
        this.banks = bankData || [];
        if (this.selectedFinance?.name?.toLowerCase() == "bank" && this.selectedFinance?.id == 0) {
            this.selectedBank = this.banks[0];
        } else {
            this.selectedBank = this.financeUtilityService.findRecursiveChildObjects(this.banks, this.selectedFinance?.id);
        }
        this.getAllBankRegisters();
    }

    onRowSelectBank(e) {
        this.selectedBank = e?.node;
        this.panel?.hide();
        this.bankName = this.selectedBank.name;
        this.getAllBankRegisters();
    }

    changePmtOption() {
        if (this.payTo == "vendor") {
            this.pmtOption = "payment";
        } else if (this.payTo == "customer") {
            this.pmtOption = "deposit";
        }
        this.setFormValidation();
    }

    onRowSelect(e) {
        if (this.selectedRegister?.txnTypeId == AccountsTransactionType.Check) {
            this.displayWriteCheck = true;
            this.displayUndepositedFunds = false;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.Deposit) {
            this.selecteddepositId = this.selectedRegister?.txnId;
            this.displayMakeDepositViewDialog = true;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.Expense) {
            this.overviewRefId = this.selectedRegister?.txnId;
            this.displayAddEditExpense = true;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.Bill) {
            this.inventoryOverviewRefId = this.selectedRegister?.txnId;
            this.inventoryOverviewRefNumber = this.selectedRegister?.referenceNumber;
            this.inventoryOverviewModule = TransactionNames.Bill;
            this.displayInventoryOverview = true;
        } else if (this.selectedRegister?.txnTypeId === AccountsTransactionType.Invoice) {
            this.inventoryOverviewRefId = this.selectedRegister?.txnId;
            this.inventoryOverviewRefNumber = this.selectedRegister?.referenceNumber;
            this.inventoryOverviewModule = TransactionNames.Invoice;
            this.displayInventoryOverview = true;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.CustomerRMA) {
            this.inventoryOverviewRefId = this.selectedRegister?.txnId;
            this.inventoryOverviewRefNumber = this.selectedRegister?.referenceNumber;
            this.inventoryOverviewModule = TransactionNames.CustomerRMA;
            this.displayInventoryOverview = true;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.ItemReceipt) {
            this.inventoryOverviewRefId = this.selectedRegister?.txnId;
            this.inventoryOverviewRefNumber = this.selectedRegister?.referenceNumber;
            this.inventoryOverviewModule = TransactionNames.ItemReceipt;
            this.displayInventoryOverview = true;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.CreditMemo) {
            this.inventoryOverviewRefId = this.selectedRegister?.txnId;
            this.inventoryOverviewRefNumber = this.selectedRegister?.referenceNumber;
            this.inventoryOverviewModule = TransactionNames.CreditMemo;
            this.displayInventoryOverview = true;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.BillPay) {
            this.inventoryOverviewRefId = this.selectedRegister?.txnId;
            this.inventoryOverviewRefNumber = this.selectedRegister?.referenceNumber;
            this.inventoryOverviewModule = TransactionNames.BillPayment;
            this.displayInventoryOverview = true;
        } else if (this.selectedRegister?.txnTypeId === AccountsTransactionType.BankRegister) {
            this.accountsTransactionMasterID = this.selectedRegister?.accountTransactionMasterId;
            this.bankRegisterId = this.selectedRegister?.txnId;
            this.getBankRegisterDetailsById(this.selectedRegister?.txnId);
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.JournalEntry) {
            this.inventoryOverviewRefId = this.selectedRegister?.accountTransactionMasterId;
            this.inventoryOverviewRefNumber = this.selectedRegister?.referenceNumber;
            this.inventoryOverviewModule = TransactionNames.JournalEntry;
            this.displayInventoryOverview = true;
        } else if (this.selectedRegister?.txnTypeId == AccountsTransactionType.FundTransfer) {
            this.selectedtransferFundId = this.selectedRegister?.txnId;
            this.displayFundTransfer = true;
        }
    }

    voidOrDelete(isVoid: boolean) {
        this.closeTransactionPanel();
        if (!!this.statementMessage) {
            this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
        } else {
            this.confirmVoidDelete(isVoid);
        }
    }

    confirmVoidDelete(isVoid: boolean) {
        const isVoidStatus = isVoid ? "Void" : "Delete";
        this.confirmationService.confirm({
            message: `Do you want to ${isVoidStatus} this Register?`,
            header: `${isVoidStatus} Confirmation`,
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                this.financeService.bankRegisterVoidDelete(this.bankRegisterId, isVoid, "RemoveBankRegister", "bankRegisterId", this.bankRegisterDetails?.[0]?.accountTransactionMasterId ?? 0).subscribe((resp) => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: `${isVoidStatus}${isVoid ? "ed" : "d"} Successfully...`,
                    });
                    this.displayAddRegister = false;
                    this.displayInventoryOverview = false;
                    this.onClose("save");
                });
            },
        });
    }

    onCloseFundTransfer(e) {
        this.getAllBankRegisters();
        this.displayFundTransfer = false;
    }

    onCloseMakeDepositViewDialog(e) {
        this.getAllBankRegisters();
        this.displayMakeDepositViewDialog = false;
    }

    onCloseExpenseDialog(e) {
        this.getAllBankRegisters();
        this.overviewRefId = 0;
        this.displayAddEditExpense = false;
    }

    // invoice
    closeViewPopup() {
        this.getAllBankRegisters();
        this.displayInventoryOverview = false;
    }

    closeWriteCheck() {
        this.getAllBankRegisters();
        this.displayWriteCheck = false;
    }

    calculateBalance() {
        this.balanceAmt = 0;
        this.bankRegisters?.forEach((e) => {
            this.balanceAmt += Number(e.amount);
        });
    }

    onClose(type): void {
        if (this.dialogType !== "add") {
            this.close.emit({ type: type });
        } else if (this.dialogType === "add" && type === "save") {
            this.close.emit({ type: type });
        } else {
            this.dialogType = "";
        }
    }

    //#region EditViewBankRegister

    view() {
        this.appMainService.isShowSpinner("loadData");
        const financialAccObservable = this.financeService.getAllFinancialAccounts(false).pipe(catchError((error) => this.handleError("Financial Account", error)));
        const vendorObservable = this.purchaseService.getAllPOVendors().pipe(catchError((error) => this.handleError("Vendor", error)));
        forkJoin([financialAccObservable, vendorObservable]).subscribe(
            ([financialAccounts, vendors]) => {
                this.appMainService.isHideSpinner("loadData");
                this.prepareFinancialAccountsData(financialAccounts);
                this.prepareVendorList(vendors);
                // this.display = false;
                this.dialogType = "VIEW";
                this.displayAddRegister = true;
                this.bandRegisterHeader = "View Register";
                this.EditBankRegisters = this.bankRegisterDetails;
                this.selectedFinance = { name: "bank" };
                this.populateEditDetails(this.EditBankRegisters);
                this.transactionForm.disable();
                this.selectedBank = this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, this.editDetails?.bankFinancialAccountId);
            },
            (error) => {
                this.appMainService.isHideSpinner("loadData");
                this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
            },
        );
    }
    private handleError(apiName: string, error: any) {
        this.appMainService.isHideSpinner("loadData");
        this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        return of(null);
    }

    viewToEditBankRegister() {
        this.transactionForm.enable();
        this.display = false;
        this.dialogType = "edit";
        this.bandRegisterHeader = "Edit Register";
    }

    populateEditDetails(bankRegister: any) {
        this.transactions.clear();
        this.isSplitAmountApplied = this.editDetails?.isSplitView;
        this.isTransactionTypePayment = this.editDetails?.isPayment;
        if (bankRegister?.[0]?.accountListTypeId === 2) {
            this.payTo = "vendor";
            if (this.editDetails?.isSplitView) {
                this.splitAccount = true;
                bankRegister?.slice(0, -1)?.forEach((data) => {
                    const entryGroup = this.fb.group({
                        id: [data.id ?? 0],
                        financialAccountId: [this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, data.financialAccountId), Validators.required],
                        amount: [data.amount, [Validators.required]],
                        transactionsmemo: [data.lineMemo ?? ""],
                    });
                    this.transactions.push(entryGroup);
                });
                this.calculateSplitViewTotalAmount();
            }
            const vendor = this.allVendorsDD?.find((vendor) => vendor?.id === bankRegister?.[0]?.referenceId);
            this.transactionForm.patchValue({
                vendorId: vendor,
                lineMemo: this.editDetails?.accountTransactionMaster?.[0]?.docNumber ?? "",
                transactionDate: this.app._showDateTimeWithZone(this.editDetails?.accountTransactionMaster[0]?.transactionDate),
                memo: this.editDetails?.accountTransactionMaster?.[0]?.memo ?? "",
                financialAccount: this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[0]?.financialAccountId),
                paymentAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount < 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount * -1 : 0,
                depositAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount > 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount : 0,
            });
        } else if (bankRegister?.[0]?.accountListTypeId === 3) {
            this.payTo = "employee";
            if (this.editDetails?.isSplitView) {
                this.splitAccount = true;
                bankRegister?.slice(0, -1)?.forEach((data) => {
                    const entryGroup = this.fb.group({
                        id: [data.id ?? 0],
                        financialAccountId: [this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, data.financialAccountId), Validators.required],
                        amount: [data.amount, [Validators.required]],
                        transactionsmemo: [data.lineMemo ?? ""],
                    });
                    this.transactions.push(entryGroup);
                });
                this.calculateSplitViewTotalAmount();
            }
            const employee = this.allUser?.find((emp) => emp?.id === bankRegister?.[0]?.referenceId);
            this.transactionForm.patchValue({
                employeeId : employee,
                lineMemo: this.editDetails?.accountTransactionMaster?.[0]?.docNumber ?? "",
                transactionDate: this.app._showDateTimeWithZone(this.editDetails?.accountTransactionMaster[0]?.transactionDate),
                memo: this.editDetails?.accountTransactionMaster?.[0]?.memo ?? "",
                financialAccount: this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[0]?.financialAccountId),
                paymentAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount < 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount * -1 : 0,
                depositAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount > 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount : 0,
            });
        }else if (bankRegister?.[0]?.accountListTypeId === 1) {
            this.payTo = "customer";
            const selectedChannel = this.accountChannels.find((data) => data?.id === bankRegister?.[0]?.channelId);
            if (this.editDetails?.isSplitView) {
                this.splitAccount = true;
                bankRegister?.slice(0, -1)?.forEach((data) => {
                    const entryGroup = this.fb.group({
                        id: [data.id ?? 0],
                        financialAccountId: [this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, data.financialAccountId), Validators.required],
                        amount: [data.amount, [Validators.required]],
                        transactionsmemo: [data.lineMemo ?? ""],
                    });
                    this.transactions.push(entryGroup);
                });
                this.calculateSplitViewTotalAmount();
            }
            this.transactionForm.patchValue({
                lineMemo: this.editDetails?.accountTransactionMaster?.[0]?.docNumber ?? "",
                accountChannelId: selectedChannel,
                transactionDate: this.app._showDateTimeWithZone(this.editDetails?.accountTransactionMaster[0]?.transactionDate),
                memo: this.editDetails?.accountTransactionMaster?.[0]?.memo ?? "",
                financialAccount: this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[0]?.financialAccountId),
                paymentAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount < 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount * -1 : 0,
                depositAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount > 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount : 0,
            });
            const event = {
                query: bankRegister?.[0]?.businessName,
                channelId: bankRegister?.[0]?.channelId,
            };
            this.filterAccount(event);
        } else {
            this.payTo = "other";
            if (this.editDetails?.isSplitView) {
                this.splitAccount = true;
                bankRegister?.slice(0, -1)?.forEach((data) => {
                    const entryGroup = this.fb.group({
                        id: [data.id ?? 0],
                        financialAccountId: [this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, data.financialAccountId), Validators.required],
                        amount: [data.amount, [Validators.required]],
                        transactionsmemo: [data.lineMemo ?? ""],
                    });
                    this.transactions.push(entryGroup);
                });
                this.calculateSplitViewTotalAmount();
            }
            this.transactionForm.patchValue({
                lineMemo: this.editDetails?.accountTransactionMaster?.[0]?.docNumber ?? "",
                transactionDate: this.app._showDateTimeWithZone(this.editDetails?.accountTransactionMaster[0]?.transactionDate),
                memo: this.editDetails?.accountTransactionMaster?.[0]?.memo ?? "",
                financialAccount: this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[0]?.financialAccountId),
                paymentAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount < 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount * -1 : 0,
                depositAmount: this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount > 0 ? this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.[this.editDetails?.accountTransactionMaster?.[0]?.accountTransactions?.length - 1]?.amount : 0,
            });
        }

        /** Payment option */
        if (this.bankRegisterDetails && this.bankRegisterDetails?.length > 0) {
            let amount = this.bankRegisterDetails[this.bankRegisterDetails.length - 1]?.amount ?? 0;
            if (amount < 0) {
                this.pmtOption = "payment";
            } else {
                this.pmtOption = "deposit";
            }
        }
    }

    //#endregion EditViewBankRegister

    allVendorList() {
        this.purchaseService.getVendorList().subscribe((vendor) => {
            this.purchaseService.getAllPOVendors().subscribe((vendor) => {
                this.prepareVendorList(vendor);
            });
        });
    }
    prepareVendorList(vendor) {
        this.allVendors = vendor;
        this.allVendorsDD = this.allVendors?.filter((vendor) => vendor.isActive == true);
    }

    isClosingStatementDate(event: string) {
        this.statementMessage = event;
    }

    closeTransactionPanel() {
        this.transactionPanel?.hide();
    }
    getTotalAmount(){
        this.totalAmount = this.transactions.controls.reduce((sum, transaction) => {
            const transactionAmount = transaction.get('amount')?.value || 0;
            return sum + transactionAmount;
        }, 0);
    }
   onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = postingInfo;
      }
}
